module.exports = __webpack_public_path__ + "img/no-activity.d74290ea.svg";